import { ColorsType } from '../types'

const Palette = {
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    perthNowRed: '#d42626',
    greyCoal: '#252525',
    greyMoonstone: '#777',
    greyStone: '#999',
    greyMarble: '#ccc',
    greyPyrite: '#e5e5e5',
    greyGlass: '#f3f3f3',
    greyBasalt: '#1b262e',
    greySlate: '#32373b',
    greyFlint: '#3c525c',
    greyShale: '#8798a1',
    greyPebble: '#97a5ad',
    blueKyanite: '#066cb6',
    blueSapphire: '#0771be',
    pinkThulite: '#dd1466',
    greenTourmaline: '#38674',
    blueCerulean: '#009FDA',
    orangeCitrine: '#c74705',
    purpleAmethyst: '#a762a6',
    tealTopaz: '#0b8478',
    greenJade: '#418702',
    grandFinal: {
        white: '#fff',
        lightBlue: '#85C3F5',
        lightBlueBorderTransparent: 'rgba(133, 195, 245, 0.3)',
        darkBlue: '#00529B',
        gradientBlue: 'linear-gradient(180deg, #01285E 0%, #004C8E 100%)',
        transparent: 'transparent',
    },
} as const

export type PerthNowPalette = typeof Palette

export type PerthNowColourMap = ColorsType<PerthNowPalette>

export const colors: PerthNowColourMap = {
    brand: Palette.perthNowRed,
    section: Palette.white,
    background: {
        primary: Palette.white,
        secondary: Palette.greyBasalt,
        tertiary: Palette.greyGlass,
    },
    palette: Palette,
    text: {
        primary: Palette.greyCoal,
        secondary: Palette.greyMoonstone,
        tertiary: Palette.white,
        heading: Palette.greyCoal,
    },
    actions: {
        link: {
            default: Palette.greyCoal,
            hover: Palette.blueSapphire,
            focus: Palette.blueKyanite,
            active: Palette.blueKyanite,
        },
        button: {
            primary: {
                text: {
                    default: Palette.white,
                    hover: Palette.white,
                    focus: Palette.white,
                    active: Palette.white,
                },
                background: {
                    default: Palette.pinkThulite,
                    hover: Palette.blueKyanite,
                    focus: Palette.blueKyanite,
                    active: Palette.blueKyanite,
                },
                border: {
                    default: Palette.pinkThulite,
                    hover: Palette.blueKyanite,
                    focus: Palette.blueKyanite,
                    active: Palette.blueKyanite,
                },
            },
            secondary: {
                text: {
                    default: Palette.white,
                    hover: Palette.white,
                    focus: Palette.white,
                    active: Palette.white,
                },
                background: {
                    default: Palette.pinkThulite,
                    hover: Palette.blueKyanite,
                    focus: Palette.blueKyanite,
                    active: Palette.blueKyanite,
                },
                border: {
                    default: Palette.pinkThulite,
                    hover: Palette.blueKyanite,
                    focus: Palette.blueKyanite,
                    active: Palette.blueKyanite,
                },
            },
        },
    },
    borders: {
        primary: Palette.greyPyrite,
        secondary: Palette.greyMarble,
    },
}
